<template>
  <div class="c-item">
    <div class="item-title">
      <div>
        <img class="headImg" src="../../assets/image/plp.png">
        <p>{{review.principal.name}}</p>
      </div>
      <div>
        <img v-for='index in review.rating' class="c-star" src="../../assets/image/comment-star.png">
      </div>
    </div>
    <p class="item-content">{{review.comment}}</p>
    <div class="item-img">
      <img v-for='img in review.images' :src="img">
    </div>
    <div class="item-info">
      <div class="info-date">评论时间: {{review.date}}</div>
      <!--<div class="info-heart">-->
        <!--<img src="../../assets/image/heart-red.png">-->
        <!--<p>1243</p>-->
      <!--</div>-->
    </div>
    <div class="item-reply" v-if='review.adminComments'>
      <p class="reply-title">官方回复 :</p>
      <p class="reply-content">亲,谢谢支持第三方兰生加夫里什减肥了是否连接上了飞机事件!的 v 老大哥立即登录冠军</p>
      <p class="reply-date">回复时间 : 2017-08-09</p>
    </div>
    <div class="item-border"></div>
  </div>
</template>
<style scoped lang="less">
  @border:rgb(238,238,238);
  .c-item {
    padding: 10px 18px;
    .item-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 8px;
      &>div {
        display: flex;
        align-items: center;
      }
      .headImg {
        width: 30px;
        height: 30px;
      }
      .c-star {
        width: 13px;
      }
    }
    .item-content {
      margin-bottom: 15px;
      color: #999999;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-box-orient: vertical;
    }
    .item-img {
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      overflow: hidden;
      &>img {
        width: 23%;
        margin-right: 2.5%;
      }
    }
    .item-info {
      color: #585858;
      font-size: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 8px 0;
      .info-date {

      }
      .info-heart {
        display: flex;
        align-items: center;
        img {
          width: 12px;
          margin-right: 4px;
        }
      }
    }
    .item-reply {
      color: #585858;
      font-size: 10px;
      padding: 7px 3px;
      background-color: #e0e0e0;
      margin-bottom: 15px;
      .reply-title {

      }
      .reply-content {
        margin: 5px 0 30px 0;
      }
      .reply-date {

      }
    }
    .item-border {
      width: 100%;
      height: 1px;
      background-color: @border;
    }
  }
</style>
<script>

    export default{
        data(){
            return{

            }
        },
        props: {
          review: Object
        },
        components:{

        }
    }

</script>



// WEBPACK FOOTER //
// src/components/common/CommentComponent.vue